/**
 * Canonical ambulance vehicle type list — shared by the provider's Vehicles
 * page, Return Trips page, and the public listing card/detail page so the
 * same internal key ("basic", "ac", ...) always resolves to the same
 * friendly label everywhere, instead of each place either duplicating this
 * map or rendering the raw internal key.
 */
export const AMBULANCE_TYPES: Record<string, string> = {
  basic: 'Basic Life Support',
  ac: 'AC Ambulance',
  icu: 'ICU on Wheels',
  ventilator: 'Ventilator',
  cardiac: 'Cardiac',
  nicu: 'Neonatal (NICU)',
  air_ambulance: 'Air Ambulance',
  mortuary: 'Mortuary Van',
};

export const ambulanceTypeLabel = (key?: string | null): string =>
  (key && AMBULANCE_TYPES[key]) || key || '';
